import { z } from 'zod'

/**
 * Runs before any of the app's client code. Zod's schema compiler probes for
 * `Function("")` on first use and falls back to its interpreter when the
 * probe throws; under the site's Content-Security-Policy (script-src without
 * 'unsafe-eval') the probe throws by design, and the browser logs an enforced
 * securitypolicyviolation on every page for a path we never take. Declaring
 * the runtime jitless skips the probe, so the parse behaves exactly as before
 * and the console stays clean. Server-side parsing (the API) is unaffected.
 */
z.config({ jitless: true })
